import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../models/globals.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigureModelService {
  apiUri: string;
  graphUri: string;
  getConfigureModelListApi = "api/GetModelConfigurationList";
  deleteConfigureModelApi = "api/DeleteModelConfiguration";
  getConfigureModelById = "api/GetModelConfigurationById";
  checkConfigureModelInUseApi = "api/CheckConfigureModelInUse";

  constructor(private readonly globals: Globals, private readonly http: HttpClient) {
    this.apiUri = this.globals.config.modelManagementApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  GetConfigureModelList() {    
    return this.http.get(this.apiUri + this.getConfigureModelListApi);
  }

  getConfigureModelDetailsById(modelConfigurationId) {
    let params = { modelConfigurationId: modelConfigurationId };
    return this.http.get(this.apiUri + this.getConfigureModelById, {
      params: params
    });
  }

  deleteConfigureModel(modelConfigurationId) {
    let params = { modelConfigurationId: modelConfigurationId };
    return this.http.delete(this.apiUri + this.deleteConfigureModelApi, {
      params: params
    });
  }

  checkConfigureModelInUse(modelConfigurationId) {
    let params = { modelConfigurationId: modelConfigurationId };
    return this.http.get(this.apiUri + this.checkConfigureModelInUseApi, {
      params: params
    });
  }
}
